export const ownerDocument = (node) =>
  (node && node.ownerDocument) || document;

export const clickedRootScrollbar = (
  event,
  doc,
) =>
  doc.documentElement.clientWidth < event.clientX ||
  doc.documentElement.clientHeight < event.clientY;
  